/**
 * Created by DejanK on 3/13/2017.
 */
import Server from './server'

export default DemoServer

DemoServer.$inject = ['$http'];
function DemoServer($http){ return Server($http, '/api-auth/') }
